import React from 'react';
import Tracking from './components/Tracking';
import theme from './themeConfig';
import {ThemeProvider} from '@material-ui/core/styles';

const App = () => {
    return ( 
        <ThemeProvider theme={theme}>
            <Tracking />
        </ThemeProvider>
    );
}
 
export default App;